import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box, Button } from '@mui/material';
import {
    secondaryText,
    mainText,
    accordionSummary,
    iconBox,
    headerWithBalans,
    statusBox, iconWithSummary
} from 'app/components/AccordionCustom/AccountSummary/AccountSummary.sx';
import WalletIcon from 'app/components/Icons/SafeIcon';
import EditNameIcon from 'app/components/Icons/EditNameIcon';
import NameChangeModal from 'app/components/NameChangeModal';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import logger from 'app/utils/logger';
import { green, yellow } from 'app/components/ThemeProvider/colors';
import {cardWithSummary} from "app/components/AccordionCustom/CardSummary/CardSummary.sx";

interface SummaryProps {
  headerText: string;
  accountText: string;
  amount: string;
  open?: boolean;
  setOpen?: (arg?: boolean) => void;
  status?: any;
  currency?: any;
}
const AccountSummary = (props: SummaryProps) => {
  const { headerText, accountText, amount, status, open, currency } = props;
  const [openNameChangeModal, setOpenNameChangeModal] = useState(false);

  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={
          accordionSummary
          // {
          //   ...accordionSummary,
          //   '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root > path': {
          //     fill: status.value !== 'closed' ? '#14191F' : '#14191F38',
          //   },
          // }
        }
      >
          <Box sx={iconWithSummary}>
              <Box
                sx={{
                  ...iconBox,
                  backgroundColor:
                    // status.value === 'closed' ? '#14191F0F' :
                    'rgba(36, 176, 126, 0.08)',
                }}
              >
                <WalletIcon
                  color={
                    // status.value === 'closed' ? 'warning' :
                    'success'
                  }
                />
              </Box>
              <Box sx={{ display: 'flex', gap: '100px', width: '100%' }}>
                <Box sx={headerWithBalans}>
                  <Box>
                    <Box sx={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                      <Typography sx={mainText}>{headerText}</Typography>
                      {/*{open && (*/}
                      {/*  <Button*/}
                      {/*    style={{ minWidth: 'fit-content', padding: 0 }}*/}
                      {/*    variant={'text'}*/}
                      {/*    onClick={() => {*/}
                      {/*      setOpenNameChangeModal(true);*/}
                      {/*    }}*/}
                      {/*  >*/}
                      {/*    <EditNameIcon*/}
                      {/*      id={'editIcon'}*/}
                      {/*      sx={{*/}
                      {/*        '&.MuiSvgIcon-root': {*/}
                      {/*          width: '24px',*/}
                      {/*          height: '24px',*/}
                      {/*        },*/}
                      {/*      }}*/}
                      {/*    />*/}
                      {/*  </Button>*/}
                      {/*)}*/}
                    </Box>
                  <Typography sx={secondaryText}>{accountText}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                    {!open && (
                      <>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                          {amount} {useCurrencySymbol(currency)}
                        </Typography>
                        <Typography sx={secondaryText}>Balans</Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
          </Box>
              <Box sx={statusBox}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                    {status === 'OPEN' ? (
                        <>
                          <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>
                          <Typography>Aktiv</Typography>
                        </>
                    ) : (
                        status === 'BLOCKED' && (
                            <>
                              <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>
                              <Typography>Bloklaşdırılmış</Typography>
                            </>
                        )
                    )}
                  </Box>
              </Box>
      </AccordionSummary>
      <NameChangeModal
        open={openNameChangeModal}
        close={setOpenNameChangeModal}
        headerText={'Hesabın adını dəyiş'}
        inputTitle={'Hesabın adı'}
        selectName={headerText}
      />
    </>
  );
};

export default AccountSummary;
